import { Link } from "@tanstack/react-router";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { LanguageSwitcher } from "./LanguageSwitcher";

const NAV: { key: string; to: string; params?: Record<string, string> }[] = [
  { key: "nav.venta", to: "/$operation/$type", params: { operation: "venta", type: "casas" } },
  { key: "nav.alquiler", to: "/$operation/$type", params: { operation: "alquiler", type: "departamentos" } },
  { key: "nav.proyectos", to: "/proyectos" },
  { key: "nav.blog", to: "/blog" },
  { key: "nav.agente", to: "/agente" },
];


export function PublicHeader() {
  const [open, setOpen] = useState(false);
  const { t } = useI18n();

  return (
    <header className="sticky top-0 z-40 border-b border-border/60 bg-background/85 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2">
          <span className="grid h-9 w-9 place-items-center rounded-md bg-primary text-primary-foreground font-serif text-lg font-bold">
            D
          </span>
          <div className="leading-tight">
            <div className="text-sm font-semibold tracking-wide text-foreground">
              Dahiana Marín
            </div>
            <div className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground">
              {t("brand.tagline")}
            </div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {NAV.map((item) => (
            <Link
              key={item.key}
              to={item.to as never}
              params={item.params as never}
              className="rounded-md px-3 py-2 text-sm font-medium text-foreground/80 transition-colors hover:bg-secondary hover:text-foreground"

              activeProps={{ className: "text-primary" }}
            >
              {t(item.key)}
            </Link>
          ))}
          <Link
            to="/vende-tu-propiedad"
            className="ml-2 inline-flex items-center rounded-md bg-accent px-4 py-2 text-sm font-semibold text-accent-foreground shadow-soft transition hover:brightness-95"
          >
            {t("nav.sell")}
          </Link>
          <LanguageSwitcher className="ml-2" />
        </nav>

        <div className="flex items-center gap-2 md:hidden">
          <LanguageSwitcher />
          <button
            onClick={() => setOpen((v) => !v)}
            className="inline-flex h-10 w-10 items-center justify-center rounded-md border border-border"
            aria-label={t("menu.open")}
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-border bg-background">
          <nav className="mx-auto flex max-w-7xl flex-col p-3">
            {NAV.map((item) => (
              <Link
                key={item.key}
                to={item.to as never}
                params={item.params as never}

                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-3 text-sm font-medium text-foreground/90 hover:bg-secondary"
              >
                {t(item.key)}
              </Link>
            ))}
            <Link
              to="/vende-tu-propiedad"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center rounded-md bg-accent px-4 py-3 text-sm font-semibold text-accent-foreground"
            >
              {t("nav.sell")}
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
